import React, { useEffect, useState } from 'react';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

export default function Consumption() {
  const [bills, setBills] = useState([]);
  useEffect(()=>onSnapshot(query(collection(db,'bills'),orderBy('createdAt','desc')),s=>setBills(s.docs.map(d=>({id:d.id,...d.data()})))),[]);

  const totals={};
  bills.forEach(b=>(b.materialsDeducted||[]).forEach(m=>{
    if(!totals[m.name]) totals[m.name]={name:m.name,unit:m.unit,qty:0};
    totals[m.name].qty+=m.qty;
  }));
  const top=Object.values(totals).sort((a,b)=>b.qty-a.qty);

  return (
    <div>
      <div className="grid4" style={{ marginBottom:16 }}>
        {top.slice(0,4).map(m=>(
          <div key={m.name} className="metric">
            <div className="metric-label">{m.name}</div>
            <div className="metric-val" style={{ fontSize:16 }}>{+m.qty.toFixed(3)} {m.unit}</div>
          </div>
        ))}
        {!top.length && <div className="metric"><div className="metric-label">Bills today</div><div className="metric-val">0</div></div>}
      </div>
      <div className="card">
        <div className="sec-title">Consumption log per bill</div>
        {!bills.length && <div style={{ textAlign:'center', padding:30, color:'#bbb' }}>No bills yet</div>}
        <table className="table">
          <thead><tr><th>Bill ID</th><th>Table</th><th>Time</th><th>Items</th><th>Materials deducted</th></tr></thead>
          <tbody>
            {bills.map(b=>(
              <tr key={b.id}>
                <td style={{ fontWeight:500, fontSize:12 }}>{b.id.slice(0,8)}</td>
                <td>{b.table}</td>
                <td style={{ fontSize:12, color:'#888' }}>{b.createdAt?.toDate?.()?.toLocaleTimeString?.()||'—'}</td>
                <td style={{ fontSize:12 }}>{(b.items||[]).map(i=>i.name).join(', ')}</td>
                <td style={{ fontSize:12 }}>{(b.materialsDeducted||[]).map(m=>`${m.name}: ${+m.qty.toFixed(3)} ${m.unit}`).join(' | ')||'—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}